// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BERelationship } from './BERelationship';
import { BEComponent } from './BEComponent';
import { BEInterface } from './BEInterface';
import { BEEntity } from './BEEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { ImplementExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/ImplementExtend';
/**
 * 实现关系 实体类
 * 实现关系
 */
export class Implement extends BERelationship {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 被实现的接口 的ID */
  private _interface_ID: string;

  /** 获取：被实现的接口 的ID */
  public get interface_ID() {
    return this._interface_ID;
  }

  /** 设置：被实现的接口 的ID */
  public set interface_ID(value: string) {
    this._interface_ID = value;
  }

  /** 被实现的接口  */
  private _interface: BEInterface;

  /** 获取：被实现的接口  */
  public get interface() {
    return this._interface;
  }

  /** 设置：被实现的接口  */
  public set interface(value: BEInterface) {
    this._interface = value;
    if (value !== null) {
      this.interface_ID = value.id;
    } else {
      this.interface_ID = '';
    }
  }

  /** 实体 的ID */
  private _entity_ID: string;

  /** 获取：实体 的ID */
  public get entity_ID() {
    return this._entity_ID;
  }

  /** 设置：实体 的ID */
  public set entity_ID(value: string) {
    this._entity_ID = value;
  }

  /** 实体  */
  private _entity: BEEntity;

  /** 获取：实体  */
  public get entity() {
    return this._entity;
  }

  /** 设置：实体  */
  public set entity(value: BEEntity) {
    this._entity = value;
    if (value !== null) {
      this.entity_ID = value.id;
    } else {
      this.entity_ID = '';
    }
  }

  constructor() {
    super();
    ImplementExtend.Init(this);
    this._component_ID = '';
    this._component = null;
    this._interface_ID = '';
    this._interface = null;
    this._entity_ID = '';
    this._entity = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Implement, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.interface_ID = element.interface_ID;
      if (hasReference && element.interface !== null) {
        this.interface = element.interface;
      }
      this.entity_ID = element.entity_ID;
      if (hasReference && element.entity !== null) {
        this.entity = element.entity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    this.interface_ID = json.Interface_ID;
    // if (json.Interface !== null) {
    //   this.interface = BEInterface.Create(json.Interface);
    // }
    this.entity_ID = json.Entity_ID;
    // if (json.Entity !== null) {
    //   this.entity = BEEntity.Create(json.Entity);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    json.Interface_ID = this.interface_ID;
    json.Entity_ID = this.entity_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): Implement {
    const implement = new Implement();
    implement.Deserialize(json);
    implement.json = json;
    return implement;
  }
}
